import { render, staticRenderFns } from "./BusinessFlows.vue?vue&type=template&id=66c635e7&"
import script from "./BusinessFlows.vue?vue&type=script&lang=js&"
export * from "./BusinessFlows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports